var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    _vm.$style.component,
    'animate__animated',
    _vm.isAnimatingRight && 'animate__bounce',
    _vm.isAnimatingWrong && 'animate__headShake'
  ],style:(Object.assign({}, {zIndex: _vm.zIndex},
    _vm.position ? {
      left: _vm.pixels(_vm.position[0]),
      top: _vm.pixels(_vm.position[1])
    } : {})),attrs:{"title":_vm.label},on:{"animationend":_vm.onAnimationEnd}},[_c('ItemGraphics',{attrs:{"imageUrl":_vm.imageUrl,"label":_vm.label,"size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }